module.exports = __webpack_public_path__ + "img/Slovakia (Slovak Republic).a848aecb.svg";